<template>
  <div class="_3">
    <div class="logo">
      <img src="/static/salesReservation/insunet_logo.png" alt="INSUNET FC" />
    </div>
    <div cla
    <div class="card">
      <div class="quote left">&ldquo;</div>
      <div class="quote right">&rdquo;</div>
      <div class="content">
        <div class="main_text">
          <span>별도의 </span>
          <span class="highlight green_bg">가입 절차 없이</span><br>
          <span>관심있는 보험 종목과 번호만 입력하시면</span><br>
          <span class="highlight underline-container">
            <span class="coffee-coupon">커피 쿠폰</span>
            <!-- <div class="underline"></div> -->
          </span>
          <span>을 드립니다.</span>
        </div>
        <div class="sub_text">
          해당 정보는 보험 상담의 용도 외에 개인 목적으로 사용하지 않습니다.
        </div>
        <button class="consultation_button" @click="handleClick">상담 신청</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsultationCard',
  props: {
    refin: {
      type: String,
      default: ''
    },
    sorce: {
      type: String,
      default: ''
    }
  },  
  methods: {
    handleClick() {
      console.log('상담 신청 버튼이 클릭되었습니다.');
      console.log('refin:', this.refin);
      console.log('sorce:', this.sorce);
      
      this.$router.push({
        path: '/sales/reservationd',
        query: {
          refin: this.refin,
          sorce: this.sorce
        }
      });
    }
  }
}
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable.min.css");
@import url('https://fonts.googleapis.com/css2?family=Potta+One&display=swap');

body, ._3 {
  font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif;
  margin: 0;
  padding: 0;
}

.logo {
  position: absolute;
  top: 7%;
  right: 7%;
  z-index: 10;
}
.logo img {
  width: 150px;
  height: 30px;
}

._3 {
  background-color: #F2F2F7;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card {
  background-color: white;
  border-radius: 30px;
  padding: 60px;
  width: 90%;
  max-width: 800px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 500px;
}

.quote {
  font-family: 'Potta One', cursive;
  font-size: 80px;
  position: absolute;
  top: 20px;
  color: #000;
}

.left {
  left: 30px;
}

.right {
  right: 30px;
}

.content {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.main_text {
  font-size: 40px;
  line-height: 1.6;
  margin-bottom: 30px;
}

.highlight {
  font-weight: bold;
}

.green_bg {
  background-color: #3BC237;
  color: white;
  padding: 1px 8px;
}

.underline-container {
  position: relative;
  display: inline-block;
}

.coffee-coupon {
  position: relative;
  color: #3BC237;
}

.coffee-coupon::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 2px;
  background-color: #3BC237;
}

.sub_text {
  font-size: 16px;
  color: #8E8E93;
  margin-bottom: 100px;
}

.consultation_button {
  background-color: #184DE5;
  color: white;
  border: none;
  border-radius: 30px;
  padding: 5px 40px;
  font-size: 30px;
  cursor: pointer;
  transition: background-color 0.3s;
  align-self: center;
  width: 300px; 
  height: 60px;
}

.consultation_button:hover {
  background-color: #1440C4;
}

</style>